import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./Button";
import { Strings } from "../Stores/StringsStore";

@observer
export class ResetFiltersButton extends Button {

	render() {
		return <Button {...this.props} title={this.props.title ? this.props.title : Strings.reader.resetFiltersButtonTooltip}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<polygon points="0 0 0 4 12 16 12 32 16 30 16 27.76 14 28.76 14 16 14 15.17 13.41 14.59 2 3.17 2 2 30 2 30 3.17 18.59 14.59 18 15.17 18 16 20 16 32 4 32 0 0 0" />
					<path d="M26.12,24l2.94-2.94a1.5,1.5,0,0,0-2.12-2.12L24,21.88l-2.94-2.94a1.5,1.5,0,0,0-2.12,2.12L21.88,24l-2.94,2.94a1.5,1.5,0,1,0,2.12,2.12L24,26.12l2.94,2.94a1.5,1.5,0,0,0,2.12-2.12Z" />
				</svg>
			</i>
		</Button>;
	}
}
